import React from 'react';
import { motion } from 'framer-motion';
export function BookMockup() {
  return <section className="py-24 bg-cream-100 relative overflow-hidden" data-id="element-20">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-terra-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-21" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-23">
          <div className="relative mb-12 group" data-id="element-24">
            <div className="absolute -inset-4 bg-gradient-to-r from-terra-500/15 to-terra-400/15 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700 rounded-3xl" data-id="element-25" />
            <img src="https://cdn.magicpatterns.com/uploads/vGKy9DQaGAhjV8F6orgSWE/heylloyd-image-1774237064218.png" alt="Libro El Código Celestial del Triunfo" className="w-full max-w-2xl mx-auto relative z-10 rounded-lg shadow-2xl shadow-black/20" data-id="element-26" />
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="text-center" data-id="element-27">
            <p className="text-2xl md:text-3xl font-heading text-brown-900 italic text-glow-gold" data-id="element-28">
              "Activa el respaldo que ningún recurso humano puede igualar."
            </p>
            <div className="w-12 h-1 bg-terra-500 mx-auto mt-6 rounded-full opacity-50" data-id="element-29" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}